export default defineNuxtPlugin(() => {
  const router = useRouter()

  router?.beforeEach((to, from) => {
    if (from.params.city && !to.params.city) {
      to.params.city = from.params.city
    }
  })
})
